import React, { useState } from "react";
import { Container, Row, Col, Button, Form, Card, Table } from "react-bootstrap";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// 🔹 Dados Simulados
const stats = {
  totalAlertas: 35,
  tempoMedioResposta: "6.5 min",
  alertasResolvidos: 28,
  alertasPendentes: 7,
  taxaResolucao: ((28 / 35) * 100).toFixed(1) + "%",
};

// 🔹 Dados de Alertas
const alertas = [
  { servidor: "Servidor-01", criticidade: "Alta", status: "Resolvido", tempoResposta: "5 min" },
  { servidor: "Servidor-02", criticidade: "Média", status: "Pendente", tempoResposta: "N/A" },
];

// 🔹 Logs de Alertas
const logsData = [
  { id: 1, server: "SRV-APP-01", alert: "CPU acima de 90%", criticidade: "Alta", tempoResposta: 5 },
  { id: 2, server: "SRV-DB-02", alert: "Banco de Dados offline", criticidade: "Crítica", tempoResposta: 7 },
];

const Reports = () => {
  const [footerText, setFooterText] = useState("Relatório gerado automaticamente por Mobili");
  const [footerColor, setFooterColor] = useState("#ff7e00");
  const [footerTextColor, setFooterTextColor] = useState("#FFFFFF");

  // 🔹 Função para gerar PDF
  const generatePDF = () => {
    const doc = new jsPDF("p", "mm", "a4");
    const currentDate = new Date().toLocaleString();

    // 🔹 Capa Profissional
    doc.setFillColor("#003366");
    doc.rect(0, 0, 210, 297, "F");
    doc.setTextColor("#FFFFFF");
    doc.setFontSize(26);
    doc.text("Relatório de Alertas", 105, 80, { align: "center" });
    doc.setFontSize(14);
    doc.text("Mobili - Monitoramento de Sistemas", 105, 100, { align: "center" });
    doc.setFontSize(12);
    doc.text(`Gerado em: ${currentDate}`, 105, 120, { align: "center" });

    doc.addPage();

    // 🔹 KPIs em Tabela
    doc.setFontSize(16);
    doc.setTextColor("#000000");
    doc.text("Resumo Geral", 10, 20);
    autoTable(doc, {
      startY: 30,
      head: [["Métrica", "Valor"]],
      body: [
        ["Total de Alertas", stats.totalAlertas],
        ["Taxa de Resolução", stats.taxaResolucao],
        ["Tempo Médio de Resposta", stats.tempoMedioResposta],
      ],
      theme: "striped",
      headStyles: { fillColor: "#003366", textColor: "#FFFFFF" },
    });

    // 🔹 Tabela de Alertas
    doc.addPage();
    doc.setFontSize(16);
    doc.text("Tabela de Alertas", 10, 20);
    autoTable(doc, {
      startY: 30,
      head: [["Servidor", "Criticidade", "Status", "Tempo de Resposta"]],
      body: alertas.map((alerta) => [alerta.servidor, alerta.criticidade, alerta.status, alerta.tempoResposta]),
      theme: "striped",
      headStyles: { fillColor: "#003366", textColor: "#FFFFFF" },
    });

    // 🔹 Tabela de Logs
    doc.addPage();
    doc.setFontSize(16);
    doc.text("Logs de Alertas", 10, 20);
    autoTable(doc, {
      startY: 30,
      head: [["ID", "Servidor", "Alerta", "Criticidade", "Tempo de Resposta"]],
      body: logsData.map((log) => [log.id, log.server, log.alert, log.criticidade, log.tempoResposta + " min"]),
      theme: "striped",
      headStyles: { fillColor: "#003366", textColor: "#FFFFFF" },
    });

    // 🔹 Rodapé
    doc.setFillColor(footerColor);
    doc.rect(0, 280, 210, 15, "F");
    doc.setTextColor(footerTextColor);
    doc.setFontSize(10);
    doc.text(footerText, 10, 289);

    doc.save("relatorio_mobili.pdf");
  };

  // 🔹 Função Fake para Download CSV
  const downloadCSV = () => {
    alert("O CSV seria gerado aqui!");
  };

  // 🔹 Função Fake para Enviar por Email
  const sendEmail = () => {
    alert("O relatório seria enviado por e-mail!");
  };

  return (
    <Container className="mt-4">
      <h2 className="text-center text-primary">Relatórios</h2>

      {/* 🔹 Estatísticas Visíveis */}
      <Row className="mb-4">
        <Col md={4}>
          <Card className="text-center p-3">
            <h5>Total de Alertas</h5>
            <h3>{stats.totalAlertas}</h3>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center p-3">
            <h5>Taxa de Resolução</h5>
            <h3>{stats.taxaResolucao}</h3>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center p-3">
            <h5>Tempo Médio de Resposta</h5>
            <h3>{stats.tempoMedioResposta}</h3>
          </Card>
        </Col>
      </Row>

      {/* 🔹 Botões de Exportação */}
      <Row className="mb-4 text-center">
        <Col>
          <Button variant="success" onClick={generatePDF}>
            📄 Baixar PDF
          </Button>{" "}
          <Button variant="warning" onClick={downloadCSV}>
            📥 Exportar CSV 
          </Button>{" "}
          <Button variant="info" onClick={sendEmail}>
            📧 Enviar por Email 
          </Button>
        </Col>
      </Row>

      {/* 🔹 Tabela de Alertas na Página */}
      <h4 className="text-center mt-4">📋 Tabela de Alertas</h4>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Servidor</th>
            <th>Criticidade</th>
            <th>Status</th>
            <th>Tempo de Resposta</th>
          </tr>
        </thead>
        <tbody>
          {alertas.map((alerta, index) => (
            <tr key={index}>
              <td>{alerta.servidor}</td>
              <td>{alerta.criticidade}</td>
              <td>{alerta.status}</td>
              <td>{alerta.tempoResposta}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default Reports;
